import { useEffect, useState } from "react";
import { Avatar, Box, Loader } from "@mantine/core";

// Wraps Mantine's Avatar and shows a small spinner overlay while the image at `src` is
// still loading, so the user knows something is happening instead of seeing a blank gap.
export function LoadingAvatar({ src, wrapperSx, spinnerSize = "xs", ...avatarProps }) {
  const [isLoading, setIsLoading] = useState(!!src);

  useEffect(() => {
    setIsLoading(!!src);
  }, [src]);

  return (
    <Box sx={{ position: "relative", width: "fit-content", ...wrapperSx }}>
      <Avatar
        src={src}
        imageProps={{
          onLoad: () => setIsLoading(false),
          onError: () => setIsLoading(false),
          // Avatars are never the above-the-fold header logo, so always safe to lazy-load.
          loading: "lazy",
        }}
        {...avatarProps}
      />
      {isLoading && (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(255,255,255,0.6)",
            borderRadius: "50%",
          }}
        >
          <Loader size={spinnerSize} />
        </Box>
      )}
    </Box>
  );
}
